import React from "react";
import {
  OHLCPriceHistoryWidgetFilters,
  OHLCProductType,
} from "../../dashboards/widgets/marketPrices/OHLCPriceHistoryWidget";
import {
  onSelectSetupMenu,
  SetupWidgetProps,
} from "../../dashboards/WidgetPanel";
import { COREHeading } from "../../../COREDesignSystem/Typography/COREHeading";
import { COREBody } from "../../../COREDesignSystem/Typography/COREBody";
import "./OHLCPriceHistory.less";
import { COREIcon } from "../../../COREDesignSystem/Content/COREIcon";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { COREButton } from "../../../COREDesignSystem/Action/COREButton";
import { Col, Row } from "antd";
import { spacing } from "../../../shared/global";

type SetupOHLCPriceHistoryWidgetProps = SetupWidgetProps<
  OHLCProductType,
  OHLCPriceHistoryWidgetFilters
>;

export const SetupOHLCPriceHistoryWidget = ({
  widgetProps,
  testID,
  carbonProducts,
  envProducts,
  powerProducts,
}: SetupOHLCPriceHistoryWidgetProps & {
  carbonProducts?: string[];
  envProducts?: string[];
  powerProducts?: string[];
}) => {
  return (
    <div className={"setup-block"}>
      <COREHeading
        level={3}
        testID={`${testID}-select-product-type`}
        marginBottom={false}
      >
        Select product type
      </COREHeading>
      <COREBody>
        Use the buttons below or the widget menu (
        {<COREIcon icon={icon({ name: "bars", style: "regular" })} size="xs" />}
        ) to configure your content preferences. You can have multiple widgets
        of this type and each can be configured separately.
      </COREBody>
      {carbonProducts && (
        <>
          <COREHeading
            level={4}
            testID={`${testID}-select-product-type`}
            marginBottom={false}
          >
            Carbon market products
          </COREHeading>
          <Row justify="center" gutter={[spacing.xs, spacing.xs]}>
            {carbonProducts.map((product) => {
              return (
                <Col key={`${product}-carbon-product`}>
                  <COREButton
                    size="lg"
                    onClick={() => {
                      onSelectSetupMenu(widgetProps, product);
                    }}
                    testID={`${testID}-setup-menu-accu-button`}
                  >
                    {product.toUpperCase()}
                  </COREButton>
                </Col>
              );
            })}
          </Row>
        </>
      )}
      {envProducts && (
        <>
          <COREHeading
            level={4}
            testID={`${testID}-select-product-type`}
            marginBottom={false}
          >
            Environmental market products
          </COREHeading>
          <Row justify="center" gutter={[spacing.xs, spacing.xs]}>
            {envProducts.map((product) => {
              return (
                <Col key={`${product}-env-product`}>
                  <COREButton
                    size="lg"
                    onClick={() => {
                      onSelectSetupMenu(widgetProps, product);
                    }}
                    testID={`${testID}-setup-menu-accu-button`}
                  >
                    {product.toUpperCase()}
                  </COREButton>
                </Col>
              );
            })}
          </Row>
        </>
      )}

      {powerProducts && (
        <>
          <COREHeading
            level={4}
            testID={`${testID}-select-product-type`}
            marginBottom={false}
          >
            Power market products
          </COREHeading>
          <Row justify="center" gutter={[spacing.xs, spacing.xs]}>
            {powerProducts.map((product) => {
              return (
                <Col key={`${product}-power-product`}>
                  <COREButton
                    size="lg"
                    onClick={() => {
                      onSelectSetupMenu(widgetProps, product);
                    }}
                    testID={`${testID}-setup-menu-accu-button`}
                  >
                    {product === "cap300" ? "$300 cap" : product.toUpperCase()}
                  </COREButton>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </div>
  );
};
